module.exports = __webpack_public_path__ + "img/popup_4.d41621ec.jpg";